import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { axiosInstance } from '../../helpers/axios';

const TRANSPARENT_PIXEL = [
  'data:image/gif;base64,',
  'R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==',
].join('');

const canLoadDirectly = src => (
  src.startsWith('blob:')
  || src.startsWith('data:')
);

const AuthImage = ({
  alt,
  fallbackSrc,
  src,
  ...props
}) => {
  const [imageSrc, setImageSrc] = useState('');

  useEffect(() => {
    let active = true;
    let objectUrl;

    setImageSrc('');
    if (!src) return undefined;

    if (canLoadDirectly(src)) {
      setImageSrc(src);
      return undefined;
    }

    axiosInstance({
      url: src,
      method: 'GET',
      responseType: 'blob',
    })
      .then(response => {
        if (!active) return;
        objectUrl = window.URL.createObjectURL(new Blob([response.data]));
        setImageSrc(objectUrl);
      })
      .catch(() => {
        if (active) setImageSrc(fallbackSrc || TRANSPARENT_PIXEL);
      });

    return () => {
      active = false;
      if (objectUrl) window.URL.revokeObjectURL(objectUrl);
    };
  }, [fallbackSrc, src]);

  return (
    <img
      src={imageSrc || fallbackSrc || TRANSPARENT_PIXEL}
      alt={alt || ''}
      {...props}
    />
  );
};

AuthImage.propTypes = {
  alt: PropTypes.string,
  fallbackSrc: PropTypes.string,
  src: PropTypes.string,
};

AuthImage.defaultProps = {
  alt: '',
  fallbackSrc: '',
  src: '',
};

export default AuthImage;
